// extracted by mini-css-extract-plugin
export var accordionWrapper = "_r2-2";
export var countryRow = "_r2-1";
export var countryRowDisabled = "_r2-4";
export var countryRowStandalone = "_r2-3";
export var inAnotherZone = "_r2-7";
export var listContainer = "_r2-0";
export var provinceRow = "_r2-5";
export var provinceRowDisabled = "_r2-6";